// The page on screen, for request ordering (CU-869fnzwwe). '/dashboard/app/' and '/dashboard/app' are the same page.
export default function currentPagePath() {
    const path = typeof window !== 'undefined' && window.location ? window.location.pathname || '' : '';
    return path.length > 1 ? path.replace(/\/+$/, '') : path;
}
